import React, { useState, useEffect } from "react";
import { useField, useFormikContext } from "formik";
import { getCommodityOwnerTotalDivision } from "../../../http/api/MasterAPI";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

const CommodityOwnerTotalDivisionSelect = ({ name, ...props }) => {
  const [listCommodityOwnerTotalDivision, setListCommodityOwnerTotalDivision] =
    useState([]);
  const { setFieldValue } = useFormikContext();
  const [field, meta, helpers] = useField(name);

  useEffect(() => {
    GetCommodityOwnerTotalDivision();
  }, []);

  async function GetCommodityOwnerTotalDivision() {
    try {
      const response = await getCommodityOwnerTotalDivision();
      const varList = response.masterVarInfo;
      const result = varList.map((element) => ({
        commodityOwnerTotalDivisionCd: element.varCd,
        commodityOwnerTotalDivisionName: element.varValue1,
      }));
      setListCommodityOwnerTotalDivision(result);
    } catch (error) {
      console.error("Failed to fetch sales record types:", error);
    }
  }

  const handleChange = (event) => {
    helpers.setValue(event.target.value);
    if (props.onChange) {
      props.onChange(event);
    }
  };

  return (
    <FormControl {...props} error={meta.touched && Boolean(meta.error)}>
      <InputLabel id={`${name}-label`} shrink>
        {props.label}
      </InputLabel>
      <Select
        labelId={`${name}-label`}
        id={name}
        {...field}
        onChange={handleChange}
        label={props.label}
        value={field.value === null ? -1 : field.value}
        inputRef={props.inputRef}
      >
        <MenuItem value={-1}>未選択</MenuItem>
        {listCommodityOwnerTotalDivision.map((type) => (
          <MenuItem
            key={type.commodityOwnerTotalDivisionCd}
            value={type.commodityOwnerTotalDivisionCd}
          >
            {type.commodityOwnerTotalDivisionName}
          </MenuItem>
        ))}
      </Select>
      {meta.touched && meta.error && (
        <FormHelperText>{meta.error}</FormHelperText>
      )}
    </FormControl>
  );
};

export default CommodityOwnerTotalDivisionSelect;
